import { noop } from 'lodash-es';
import { Maybe } from '@iss/libs/graphql';
import { NgControl } from '@angular/forms';
import {
  Component,
  ContentChild,
  Input,
  Self,
  TemplateRef,
} from '@angular/core';
import { NgFor, NgForOf, NgTemplateOutlet } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';

import { ControlValueAccessor } from '../forms';

@Component({
  selector: 'iss-inclusive-buttons[ngModel],iss-inclusive-buttons[formControlName],iss-inclusive-buttons[formControl]',
  templateUrl: './inclusive-buttons.component.html',
  styleUrls: [ './inclusive-buttons.component.scss' ],
  standalone: true,
  imports: [
    NgFor,
    NgForOf,
    NgTemplateOutlet,
  ],
})
export class InclusiveButtonsComponent<T, K = T> implements ControlValueAccessor<K[]> {
  public onChange: (value: K[]) => unknown = noop;
  public onTouched: () => unknown = noop;
  public disabled = false;
  public value!: SelectionModel<K>;

  @Input({ required: true }) public items!: readonly T[];
  @Input() public identityFn: (item: T) => K = (item) => item as unknown as K;
  @Input() public textFn: (item: T) => string = (item) => `${ String(item) }`;
  @Input() public readonly: Maybe<boolean>;

  @ContentChild(TemplateRef) public templateRef?: TemplateRef<T>;

  public constructor(@Self() public readonly ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }

  public registerOnChange(fn: (value: K[]) => unknown): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => unknown): void {
    this.onTouched = fn;
  }

  public setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  public writeValue(value: K[]): void {
    this.value = new SelectionModel(true, value);
  }

  public onModelChange(item: T): void {
    if (this.readonly) return;
    this.value.toggle(this.identityFn(item));
    this.onChange(this.value.selected);
  }
}
